rdefine('app/products/properties/PicturesVR',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'fg-line vrproperty',
        initialize:function(options) {
            var key = 'vr_props_'+options.lmodel.get("language")+"_"+options.lmodel.collection.ndx+"_"+this.model.get("id");
            this.vr = new VRProperty(this.el,key);
        }
    });
});